import Login from "./views/shared/Login.jsx";
import TrocarSenha from "./views/admin/seguranca/TrocarSenha.jsx";
import EsqueceuSenha from "./views/shared/EsqueceuSenha.jsx";

import DashBoard from "./views/admin/DashBoard.jsx";
import Home from "./views/admin/Home.jsx";

import PlanosColetaList from "./views/admin/coleta/PlanosColetaList.jsx";
import PontosColetaList from "./views/admin/coleta/PontosColetaList.jsx";

import ConcessionariasList from "./views/admin/cadastros/ConcessionariasList.jsx";
import VeiculosList from "./views/admin/cadastros/VeiculosList.jsx";
import Regional from "./views/admin/cadastros/Regional.jsx";
import Territorio from "./views/admin/cadastros/Territorio.jsx";
import ModalidadesColetaList from "./views/admin/cadastros/ModalidadesColetaList.jsx";
import JustificativaList from "./views/admin/cadastros/JustificativaList.jsx";
import DestinosList from "./views/admin/cadastros/DestinosList.jsx";

import UsuariosList from "./views/admin/seguranca/UsuariosList.jsx";
import Setup from "./views/admin/seguranca/Setup.jsx";

import AnaliseOrdemColetaList from "./views/admin/avaliacao-os/AnaliseOrdemColetaList.jsx";
import AnaliseOrdemColetaMap from "./views/admin/avaliacao-os/AnaliseOrdemColetaMap.jsx";
import OrdemColetaPesquisa from "./views/admin/coleta/OrdemColetaPesquisa.jsx";
import Monitoramento from "./views/admin/monitoramento/Monitoramento.jsx";
import MonitoramentoTV from "./views/admin/monitoramento/MonitoramentoTV.jsx";
import DelimitacaoGeograficaSetoresList from "./views/admin/cadastros/DelimitacaoGeograficaSetoresList.jsx";
import HistoricoList from "./views/admin/historico/HistoricoList.jsx";
import PontoColetaNaoExecucao from "./views/admin/coleta/PontoColetaNaoExecucao.jsx";
import IndiceQualidadeList from "./views/admin/cadastros/IndiceQualidadeList.jsx";
import IndiceAtendimentoList from "./views/admin/cadastros/IndiceAtendimentoList.jsx";

//Relatórios
import Relatorios from "./views/admin/Relatorios/Relatorios.jsx";
import AtendimentoAnalitico from "./views/admin/Relatorios/AtendimentoAnalitico";
import AtendimentoSintetico from "./views/admin/Relatorios/AtendimentoSintetico";
import Inconformidades from "./views/admin/Relatorios/Inconformidades";
import Ocorrencias from "./views/admin/Relatorios/Ocorrencias";
import ProdutividadeAnalitico from "./views/admin/Relatorios/ProdutividadeAnalitico";
import ProdutividadeSintetico from "./views/admin/Relatorios/ProdutividadeSintetico";
import QualidadeAnalitico from "./views/admin/Relatorios/QualidadeAnalitico";
import QualidadeSintetico from "./views/admin/Relatorios/QualidadeSintetico";
import HistoricoAtendimentoPontoColeta from "./views/admin/Relatorios/HistoricoAtendimentoPontoColeta/index.jsx";

import { faChartSimple, faMagnifyingGlass, faTv, faMap, faFileSignature, faMapLocationDot, faFlag, faTags, faWarehouse,
  faTruck, faLocationPin, faTruckRampBox, faHandPointRight, faFile,
  faHeadset,
  faUser,
  faFileInvoice,
  faLocationDot,
  faHome
 } from '@fortawesome/free-solid-svg-icons';

var routes = [
  {
    path: "/login",
    name: "Login",
    icon: "",
    component: Login,
    layout: "/auth",
    sidebar: false
  },  
  {
    path: "/esqueceusenha",
    name: "EsqueceuSenha",
    icon: "",
    component: EsqueceuSenha,
    layout: "/auth",
    sidebar: false
  },  
  {
    path: "/home",
    name: "Home",
    icon: faHome,
    component: Home,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: faChartSimple,
    component: DashBoard,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/monitoramento",
    name: "Monitoramento",  
    icon: faTv,
    component: Monitoramento,
    layout: "/mapaordem",
    sidebar: true
  },  
  {
    path: "/ordemserviçopesquisa",
    name: "Pesquisa de Ordens",
    icon: faMagnifyingGlass,
    component: OrdemColetaPesquisa,
    layout: "/admin",
    sidebar: true
  },         
  {
    path: "/historico",
    name: "Histórico de Execução",
    icon: faFileSignature,
    component: HistoricoList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/divisaoadministrativa",
    name: "Divisão Administrativa",
    icon: faMap,
    component: Regional,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/delimitacaoGeografica",
    name: "Delimitação Geografica",
    icon: faMapLocationDot,
    component: DelimitacaoGeograficaSetoresList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/areasoperacionais",
    name: "Áreas Operacionais",
    icon: faFlag,
    component: Territorio,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/modalidadesservico",
    name: "Modalidades de Serviço",
    icon: faTags,
    component: ModalidadesColetaList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/concessionarias",
    name: "Concessionárias",
    icon: faWarehouse,
    component: ConcessionariasList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/recursos",
    name: "Recursos",
    icon: faTruck,
    component: VeiculosList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/localexecucao",
    name: "Locais de Execução",
    icon: faLocationDot,
    component: PontosColetaList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/localnaoexecucao",
    name: "Locais de Não Execução",
    icon: faLocationPin,
    component: PontoColetaNaoExecucao,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/planostrabalho",
    name: "Planos de Trabalho",
    icon: faLocationDot,
    component: PlanosColetaList,
    layout: "/admin",
    sidebar: true
  },       
  {
    path: "/destino",
    name: "Destinos",
    icon: faTruckRampBox,
    component: DestinosList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/justificativa",
    name: "Justificativas",
    icon: faHandPointRight,
    component: JustificativaList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/relatorios",
    name: "Relatórios",  
    icon: faFile,
    component: Relatorios,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/indiceAtendimento",
    name: "Índice de Atendimento",
    icon: faHeadset,
    component: IndiceAtendimentoList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/indiceQualidade",
    name: "Índice de Qualidade",
    icon: faFileInvoice,
    component: IndiceQualidadeList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/usuarios",
    name: "Usuários",
    icon: faUser,
    component: UsuariosList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/setup",
    name: "Setup",    
    component: Setup,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/analiseordem",
    name: "Análise de Ordem de Serviço",    
    component: AnaliseOrdemColetaList,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/analiseordemmap",
    name: "Mapa de Ordem de Serviço",    
    component: AnaliseOrdemColetaMap,    
    layout: "/mapaordem",
    sidebar: false
  },
  {
    path: "/monitoramentoTV",
    name: "Monitoramento TV",    
    component: MonitoramentoTV,    
    layout: "/mapaordem",
    sidebar: false
  },
  {
    path: "/trocarsenha",
    name: "Trocar Senha",    
    component: TrocarSenha,
    layout: "/admin",
    sidebar: false
  },
 

 // Relatórios path
  {
    path: "/relatorio/ProdutividadeAnalitico",
    name: "Relatório de Produtividade Analítico",    
    component: ProdutividadeAnalitico,
    layout: "/admin",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/ProdutividadeSintetico",
    name: "Relatório de Produtividade Sintético",    
    component: ProdutividadeSintetico,
    layout: "/admin",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/Inconformidades",
    name: "Relatório de Inconformidades",    
    component: Inconformidades,
    layout: "/admin",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/Ocorrencias",
    name: "Relatório de Ocorrências",    
    component: Ocorrencias,
    layout: "/admin",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/AtendimentoAnalitico",
    name: "Relatório de Atendimento Analítico",    
    component: AtendimentoAnalitico,
    layout: "/admin",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/AtendimentoSintetico",
    name: "Relatório de Atendimento Sintético",    
    component: AtendimentoSintetico,
    layout: "/admin",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/QualidadeAnalitico",
    name: "Relatório de Qualidade Analítico",    
    component: QualidadeAnalitico,
    layout: "/admin",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/QualidadeSintetico",
    name: "Relatório de Qualidade Sintético",    
    component: QualidadeSintetico,
    layout: "/admin",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/HistoricoAtendimentoPontoColeta",
    name: "Relatório de Histórico de Atendimento dos Pontos de Coleta",    
    component: HistoricoAtendimentoPontoColeta,
    layout: "/admin",
    sidebar: false,
    relatorio: true
  },
];

export default routes;
